function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_347_1336",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 7C16 7.67 16 8.33 16 9C17.2 9 18.76 9 20 9C20 8.33 20 7.67 20 7C18.76 7 17.2 7 16 7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 13.61C14.96 14.32 16.21 15.26 17.2 16C17.6 15.47 18 14.93 18.4 14.4C17.41 13.66 16.16 12.72 15.2 12C14.8 12.54 14.4 13.08 14 13.61Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4 1.6C18 1.07 17.6 0.53 17.2 0C16.21 0.74 14.96 1.68 14 2.4C14.4 2.93 14.8 3.47 15.2 4C16.16 3.28 17.41 2.35 18.4 1.6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 5C0.9 5 0 5.9 0 7V9C0 10.1 0.9 11 2 11H3V15H5V11H6L11 14V2L6 5H2ZM7.03 6.71L9 5.53V10.47L7.03 9.29L6.55 9H2V7H6.55L7.03 6.71Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.5 8C13.5 6.67 12.92 5.47 12 4.65V11.34C12.92 10.53 13.5 9.33 13.5 8Z"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16 7C16 7.67 16 8.33 16 9C17.2 9 18.76 9 20 9C20 8.33 20 7.67 20 7C18.76 7 17.2 7 16 7Z",
  stroke: "#EBEBEB",
  strokeWidth: 2,
  mask: "url(#path-1-inside-1_347_1336)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14 13.61C14.96 14.32 16.21 15.26 17.2 16C17.6 15.47 18 14.93 18.4 14.4C17.41 13.66 16.16 12.72 15.2 12C14.8 12.54 14.4 13.08 14 13.61Z",
  stroke: "#EBEBEB",
  strokeWidth: 2,
  mask: "url(#path-1-inside-1_347_1336)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4 1.6C18 1.07 17.6 0.53 17.2 0C16.21 0.74 14.96 1.68 14 2.4C14.4 2.93 14.8 3.47 15.2 4C16.16 3.28 17.41 2.35 18.4 1.6Z",
  stroke: "#EBEBEB",
  strokeWidth: 2,
  mask: "url(#path-1-inside-1_347_1336)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2 5C0.9 5 0 5.9 0 7V9C0 10.1 0.9 11 2 11H3V15H5V11H6L11 14V2L6 5H2ZM7.03 6.71L9 5.53V10.47L7.03 9.29L6.55 9H2V7H6.55L7.03 6.71Z",
  stroke: "#EBEBEB",
  strokeWidth: 2,
  mask: "url(#path-1-inside-1_347_1336)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 8C13.5 6.67 12.92 5.47 12 4.65V11.34C12.92 10.53 13.5 9.33 13.5 8Z",
  stroke: "#EBEBEB",
  strokeWidth: 2,
  mask: "url(#path-1-inside-1_347_1336)"
});
var SvgCrmIcon = function SvgCrmIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrmIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crm-icon.c68a4167.svg";
export { ForwardRef as ReactComponent };